module.exports = __webpack_public_path__ + "img/MarvaImg.17b77b66.png";